import {
  subscribeToBusker,
  unsubscribeFromBusker,
} from "@/services/supabase-service";
import { useBuskerStore } from "@/store/busker";
import { Busker } from "@/types/type";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { Image } from "expo-image";
import { router } from "expo-router";
import { useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

const BuskerCard = ({
  busker,
  styling,
}: {
  busker: Busker;
  styling?: string;
}) => {
  const { setSelectedBusker } = useBuskerStore();
  const [isSubscribed, setSubscibed] = useState(busker.subscribed);

  const OnSubscribePress = () => {
    if (busker.id) {
      if (isSubscribed) {
        unsubscribeFromBusker(busker.id);
        setSubscibed(false);
        console.log("Unsubscribed");
      } else {
        subscribeToBusker(busker.id);
        setSubscibed(true);
        console.log("Subscribed");
      }
    }
  };

  return (
    <View
      className={`bg-white p-2 rounded-lg shadow-none w-full items-center m-1 `}
    >
      <TouchableOpacity
        className="g-white p-2 rounded-lg shadow-none w-full items-center m-1"
        onPress={() => {
          router.push(`/busker-details?id=${busker.id}`);
        }}
      >
        <View style={styles.container} className="relative w-full h-[250px]">
          <Image
            source={
              busker.profile_image
                ? busker.profile_image
                : require("../assets/images/account.svg")
            }
            style={styles.image}
            contentFit="contain"
            transition={1000}
            cachePolicy={"memory-disk"}
          />
        </View>

        <View className="w-full">
          <Text className="text-xl font-semibold mb-0">{busker.full_name}</Text>
          <Text className="text-l font-semibold mt-0">
            {busker.description}
          </Text>
        </View>

        <View className="w-full">
          <TouchableOpacity
            className="w-[20px] h-[20px] rounded-lg flex-row items-center justify-center"
            onPress={() => {
              setSelectedBusker(busker);
              router.push("/busker-create");
            }}
          >
            <MaterialCommunityIcons name="human-edit" size={24} />
          </TouchableOpacity>
        </View>

        <View
          style={styles.container}
          className="absolute top-2 right-2 h-[50px] w-[50px] "
        >
          <TouchableOpacity onPress={OnSubscribePress}>
            {isSubscribed ? (
              <FontAwesome name="bookmark" size={24} color="black" />
            ) : (
              <FontAwesome name="bookmark-o" size={24} color="black" />
            )}
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    //flex: 1,
    //backgroundColor: '#fff',
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    flex: 1,
    width: "100%",
    fontSize: 100,
    alignItems: "center",
    justifyContent: "center",

    //backgroundColor: '#0553',
  },
});

export default BuskerCard;
